import { render, staticRenderFns } from "./BudgetPatCreate.vue?vue&type=template&id=ab0766a8&scoped=true&"
import script from "./BudgetPatCreate.vue?vue&type=script&lang=js&"
export * from "./BudgetPatCreate.vue?vue&type=script&lang=js&"
import style0 from "./BudgetPatCreate.vue?vue&type=style&index=0&id=ab0766a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0766a8",
  null
  
)

export default component.exports